import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const anyOfFilterModelName = 'any_of_filter';

export type AnyOfFilterModel = BaseFilterModel<
  number[],
  typeof anyOfFilterModelName
>;

export type RenderOptionsList = {
  label: string;
  value: number;
}[];

export type AnyOfFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;
  options: RenderOptionsList;
  closeWhenChanged?: boolean;
};

export type AnyOfDataGridFilter = DataGridFilter<
  AnyOfFilterModel,
  AnyOfFilterParams
>;

type CreateAnyOfFilterModelParams = {
  value: number[];
  filterName: string;
};
export const createAnyOfFilterModel = ({
  value,
  filterName,
}: CreateAnyOfFilterModelParams): AnyOfFilterModel => {
  return {
    filterModelName: anyOfFilterModelName,
    value,
    filterName,
  };
};
